export function DateTimeFormat(
  options?: Intl.DateTimeFormatOptions | undefined,
) {
  return new Intl.DateTimeFormat(
    typeof window !== 'undefined' ? navigator?.language : undefined,
    options,
  );
}
